import { IObjectState } from "~/state/types"

export const commonObjectState = <T>(): IObjectState<T | null> => ({
  isError: false,
  isSuccess: false,
  isLoading: false,
  isLoaded: false,
  errorData: null,
  options: {},
  data: null,
})
